import { type ReactElement, useCallback, useState } from 'react'
import Router from 'next/router'
import SearchIcon from '../SearchIcon'
import { transactionsProxy } from '../../../../proxies/transactionsProxy'
import { APP_TRANSACTIONS_PATH } from '../../../../../pages/app/transactions'

export function SearchBar (): ReactElement {
  const [value, setValue] = useState('')

  const handleSubmit = useCallback((e: React.SyntheticEvent) => {
    e.preventDefault()
    transactionsProxy.filters.search = value
    void Router.push(APP_TRANSACTIONS_PATH)
    setValue('')
  }, [setValue, value])

  return (
    <form
      className="h-10 w-80 bg-wpy-light-gray-100 cursor-pointer border border-wpy-medium-gray-300 text-sm rounded flex pr-2"
      onSubmit={handleSubmit}
    >
      <input
        type="search"
        name="search"
        placeholder="Search Transactions"
        className="flex-grow px-4 rounded text-sm focus:outline-none bg-wpy-light-gray-100"
        onChange={(e) => { setValue(e.target.value) }}
        value={value}
      />
      <div className="flex justify-center items-center">
        <div className="h-4 w-4">
          <SearchIcon />
        </div>
      </div>
    </form>
  )
}
